import { useCallback } from 'react';

import { getLegacyListingUrl } from '@app/helpers';
import { useMapSearch } from '@app/hooks';

export function useMapBackNavigation() {
    const { searchCriteria, filters, locationDetails } = useMapSearch();

    const navigateToListing = useCallback(() => {
        const legacyUrl = getLegacyListingUrl(searchCriteria, filters, locationDetails);

        window.location.href = legacyUrl;
    }, [searchCriteria, filters, locationDetails]);

    return {
        navigateToListing,
    };
}
